/**
 * dd-tailor-destinations-second.js — 定制游「按目的地展示」二级页交互
 *
 * 职责（轻量，无依赖，失效静默）：
 *   1. 锚点平滑滚动：点击 Popular Destinations 卡片或 Hero 按钮平滑滚动到对应分组，
 *      并补上吸顶头部的偏移（scroll-margin-top 已在 CSS 设置）。
 *
 * 注意：目的地卡片是网格、非吸顶导航，故不做 scrollspy；点击即滚动定位到分组即可。
 */

;(function () {
  'use strict'

  var scrollLinks = document.querySelectorAll('a[data-dd-dest-scroll]')
  for (var i = 0; i < scrollLinks.length; i++) {
    scrollLinks[i].addEventListener('click', function (e) {
      var href = this.getAttribute('href')
      if (!href || href.charAt(0) !== '#') return
      var target = document.getElementById(href.slice(1))
      if (!target) return
      e.preventDefault()
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      if (history.replaceState) history.replaceState(null, '', href)
    })
  }
})()
